export default __webpack_public_path__ + "static/media/yd-logo.0c2b1f30.png";